<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
>
  <p-dropdown
    [id]="id"
    [tabindex]="getTabIndex()"
    [options]="getOptions()"
    [optionLabel]="getOptionLabel()"
    [optionValue]="getOptionValue()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [showClear]="getShowClear()"
    [dropdownIcon]="getDropdownIcon()"
    [filter]="hasFilter()"
    [filterBy]="getFilterBy()"
    [filterFields]="getFilterFields()"
    [filterPlaceholder]="getFilterPlaceholder()"
    [appendTo]="getAppendTo()"
    attr.aria-describedby="{{ id }}-help"
    styleClass="w-full {{ getInputStyleClass() }}"
    (onChange)="change.emit($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
    (onFilter)="onFilter.emit($event)"
    [virtualScroll]="getVirtualScroll()"
    [virtualScrollItemSize]="getVirtualScrollSize()" 
    [group]="getGroup()"
  >
    <ng-content />
  </p-dropdown>
</eo-base-form-control>
